module.exports = __webpack_public_path__ + "static/sudameris_logo-6b61ec1edccbeab47978bba9018b4dcf.png";